import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function TeamBadge({ image, name, role, credentials, socials }) {
  return (
    <div className="premium-founder-badge-card mShadow1">
      {/* Executive Portrait Frame Container */}
      <div className="founder-portrait-wrapper">
        <img 
          src={image} 
          alt={`${name}, ${role}`} 
          className="founder-portrait-img" 
          loading="lazy"
        />
        <div className="portrait-cinematic-overlay" />
        
        {/* Dynamic Social Action Tray Dock */}
        <div className="founder-social-dock">
          {socials?.facebook && (
            <a href={socials.facebook} target="_blank" rel="noreferrer" className="social-dock-link" aria-label="Facebook Profile">
              <FaFacebookF />
            </a>
          )}
          {socials?.twitter && (
            <a href={socials.twitter} target="_blank" rel="noreferrer" className="social-dock-link" aria-label="X Profile">
              <FaXTwitter />
            </a>
          )}
          {socials?.linkedin && (
            <a href={socials.linkedin} target="_blank" rel="noreferrer" className="social-dock-link" aria-label="LinkedIn Profile">
              <FaLinkedinIn />
            </a>
          )}
        </div>
      </div>

      {/* Corporate Identity Information Layer */}
      <div className="founder-identity-block">
        <div className="identity-header-strip">
          <span className="founder-professional-role">{role}</span>
          {credentials && <span className="founder-credential-tag">{credentials}</span>}
        </div>
        <h4 className="founder-fullname-title">{name}</h4>
        <div className="identity-gold-divider-line" />
      </div>
    </div>
  );
}